import TextField from '@mui/material/TextField'
import {AdapterDateFns} from '@mui/x-date-pickers/AdapterDateFns'
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider'
import {DatePicker} from '@mui/x-date-pickers/DatePicker'
import {FormControl, styled} from '@mui/material'
import {DateTimePicker} from '@mui/x-date-pickers'
import moment from 'moment'
import {useDispatch} from 'react-redux'
import {FC, useEffect, useState} from 'react'
import * as bancas from '../redux/reducers'
import * as filter from '../../../redux-commons/FilterRedux/filterRedux'
import * as component from '../../../components/redux/componentRedux'

type Props = {
  label: string
  showHour?: boolean
  id?: string
  formName?: string
  tabName?: string
  defaultValue?: Date
  required?: boolean
  validateField?: boolean
  datePickerReadOnly?: boolean
  objectSelected?: number
  handleDateChange?: (date: string) => void
}

export const CustomDateInputBancas = styled(TextField)(({theme}) => ({
  '& .MuiOutlinedInput-root': {
    borderRadius: '8px',
  },
  '& .MuiInputBase-input': {
    padding: '13.5px 14px',
    fontWeight: '500',
  },
}))

export const InputDatePickerBanCas: FC<Props> = ({
  label,
  showHour,
  id,
  tabName,
  formName,
  defaultValue,
  required,
  objectSelected,
  validateField,
  datePickerReadOnly,
  handleDateChange,
}) => {
  const [value, setValue] = useState<Date | null>(null)
  const [labelInput, setLabelInput] = useState(label)
  const [inputMaxDate, setInputMaxDate] = useState<Date | undefined>(undefined)
  const dispatch = useDispatch()

  const handleChangeValue = (newValue: Date | null) => {
    setValue(newValue)
  }

  const writeDataForm = (value: any) => {
    if (showHour) {
      value = value ? moment(value).format('YYYY/MM/DD HH:mm') : ''
    } else {
      value = value ? moment(value, 'DD/MM/YYYY').format('YYYY/MM/DD') : ''
    }
    if (handleDateChange) handleDateChange(value)
    if (formName && !formName.toLocaleLowerCase().includes('filter')) {
      let data = {
        key: id ? id : '',
        value: value,
        tab: tabName ? tabName : '',
        form: formName,
        objectSelected: objectSelected ? objectSelected : 0,
      }
      dispatch(bancas.actions.addBancasInfors(data))
    } else if (formName && formName.toLocaleLowerCase().includes('filter')) {
      let data = {
        field: id ? id : '',
        value: value,
        filterForm: formName,
      }
      dispatch(filter.actions.updateFilterInfo(data))
    }
  }

  const handleAcceptData = (data: any) => {
    writeDataForm(data)
  }

  const handleBlur = (e: any) => {
    let formatDate = e.target.value.toLowerCase()
    if (formatDate.includes(' pm') || formatDate.includes(' am')) {
      formatDate = moment(formatDate, 'DD/MM/YYYY h:mm a').toDate()
      if (id && id == 'startDate') {
        let today = moment().format('YYYY/MM/DD')
        let test2 = moment(e.target.value, 'DD/MM/YYYY h:mm a').format('YYYY/MM/DD')
        let test = moment(today).isAfter(test2)
        if (test) {
          setValue(defaultValue ? defaultValue : null)
          if (handleDateChange) handleDateChange('startDate')
          return
        }
      }
      if (formatDate == 'Invalid date') {
        if (handleDateChange) handleDateChange('Invalid date')
        setValue(null)
        return
      }
      writeDataForm(formatDate)
    } else {
      if (moment(e.target.value, 'DD/MM/YYYY').format('DD/MM/YYYY') == 'Invalid date') {
        setValue(null)
        return
      }
      if (id && id.toLowerCase().includes('birthday')) {
        let today = moment().format('YYYY/MM/DD')
        let date = moment(e.target.value, 'DD/MM/YYYY').format('YYYY/MM/DD')
        let test = moment(date).isAfter(today)
        if (test) {
          writeDataForm('')
          setValue(null)
        } else writeDataForm(e.target.value)
      } else writeDataForm(e.target.value)
    }
  }

  useEffect(() => {
    if (id && (id.toLowerCase().includes('birthday') || id == 'startDate')) {
      setInputMaxDate(moment().toDate())
    }
  }, [id])

  useEffect(() => {
    setValue(defaultValue ? defaultValue : null)
  }, [defaultValue])

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <div className='field-wrapper'>
        <FormControl error={validateField} sx={{width: '100%'}}>
          {/* <InputLabel id={labelInput} htmlFor={id} variant='outlined'>
            {labelInput} {required && <span className='input-require'>*</span>}
          </InputLabel> */}
          {showHour ? (
            <DateTimePicker
              value={value}
              mask='__/__/____ __:__ _M'
              inputFormat='dd/MM/yyyy hh:mm a'
              onChange={(newValue) => handleChangeValue(newValue)}
              onAccept={(data) => handleAcceptData(data)}
              minDate={inputMaxDate}
              readOnly={datePickerReadOnly}
              disabled={datePickerReadOnly}
              renderInput={(params) => (
                <CustomDateInputBancas
                  {...params}
                  inputProps={{
                    ...params.inputProps,
                    id: 'test',
                    placeholder: 'Ngày/Tháng/Năm Giờ/Phút',
                  }}
                  InputLabelProps={{required: required}}
                  autoComplete='off'
                  error={validateField}
                  onBlur={handleBlur}
                  label={labelInput}
                  fullWidth
                />
              )}
            />
          ) : (
            <DatePicker
              mask='__/__/____'
              inputFormat='dd/MM/yyyy'
              value={value}
              onChange={(newValue) => handleChangeValue(newValue)}
              onAccept={(data) => handleAcceptData(data)}
              readOnly={datePickerReadOnly}
              disabled={datePickerReadOnly}
              maxDate={inputMaxDate}
              renderInput={(params) => (
                <CustomDateInputBancas
                  {...params}
                  inputProps={{
                    ...params.inputProps,
                    id: 'test',
                    placeholder: 'Ngày/Tháng/Năm',
                  }}
                  onBlur={handleBlur}
                  InputLabelProps={{required: required}}
                  error={validateField}
                  label={labelInput}
                  variant='outlined'
                  autoComplete='off'
                  fullWidth
                />
              )}
            />
          )}
        </FormControl>
      </div>
    </LocalizationProvider>
  )
}
